import React from 'react';
import { useSearchkit } from '@searchkit/client';
import classNames from 'classnames';
import Button from '../../../Button';
var makeSafeForCSS = function makeSafeForCSS(value) {
  return encodeURIComponent(value).replace(/\.|%[0-9a-z]{2}/gi, '');
};
export var ChipFacet = function ChipFacet(_ref) {
  var facet = _ref.facet;
  var api = useSearchkit();
  return /*#__PURE__*/React.createElement("div", {
    className: "Facet ChipFacet",
    key: facet.identifier
  }, /*#__PURE__*/React.createElement("span", null, facet.label), /*#__PURE__*/React.createElement("div", null, facet.entries.map(function (entry) {
    var isSelected = api.isFilterSelected({
      identifier: facet.identifier,
      value: entry.label
    });
    var classes = classNames('Button--Chip', makeSafeForCSS("Button--".concat(entry.label)), {
      'Button--selected': isSelected
    });
    return /*#__PURE__*/React.createElement(Button, {
      className: classes,
      disabled: parseInt(entry.count) === 0,
      onClick: function onClick() {
        api.toggleFilter({
          identifier: facet.identifier,
          value: entry.label
        });
        api.setPage({
          from: 0
        });
        api.search();
      }
    }, entry.label);
  })));
};
ChipFacet.DISPLAY = 'ChipFacet';
export default ChipFacet;